import { render, staticRenderFns } from "./prescriptionView.vue?vue&type=template&id=49c88cde&scoped=true"
import script from "./prescriptionView.vue?vue&type=script&lang=js"
export * from "./prescriptionView.vue?vue&type=script&lang=js"
import style0 from "./prescriptionView.vue?vue&type=style&index=0&id=49c88cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c88cde",
  null
  
)

export default component.exports